import ExtraServiceDetailsList from "@/views/ExtraServiceDetails/ExtraServiceDetailsList.vue";
import EditExtraServiceDetails from "@/views/ExtraServiceDetails/EditExtraServiceDetails.vue";
const routes = [
    {
        path: "/admin/extra-service-details/list",
        name: "ExtraServiceDetailsList",
        component: ExtraServiceDetailsList,
    },
    {
        path: "/admin/extra-service-details/edit/:uuid",
        name: "EditExtraServiceDetails",
        component: EditExtraServiceDetails,
    },
];
export default routes;
